import { Paragraph } from '@app/shared/ui/atoms/Common';

interface SummaryRowProps {
  icon: string;
  iconWidth?: number;
  value: number;
  unit: string;
}

export function SummaryRow({ icon, iconWidth = 36, value, unit }: SummaryRowProps) {
  return (
    <div className="grid grid-cols-[46px_1fr_32px] items-center gap-1">
      <div className="flex gap-[2px]">
        <Paragraph size="lg">&asymp;</Paragraph>
        <img src={icon} width={iconWidth} alt="icon" />
      </div>
      <span className="rounded-md bg-secondary p-[3px_5px] text-xl font-semibold text-blue-primary">
        {Number(value.toFixed(0)).toLocaleString()}
      </span>
      <span className="font-semibold w-fit">{unit}</span>
    </div>
  );
}
